const initialState = {
  loading: false,
  account: null,
  smartContract: null,
  smartContract2: null,
  smartContract3: null,
  web3: null,
  chainID: null,
  Con: null,
  Pan: null,
  Tok: null,
  link: null,
  logo: null,
  errorMsg: "",
};

const blockchainReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CONNECTION_REQUEST":
      return {
        ...initialState,
        loading: true,
      };
    case "CONNECTION_SUCCESS":
      return {
        ...state,
        loading: false,
        account: action.payload.account,
        smartContract: action.payload.smartContract,
        smartContract2: action.payload.smartContract2,
        smartContract3: action.payload.smartContract3,
        web3: action.payload.web3,
        chainID: action.payload.chainID,
        Con: action.payload.Con,
        Pan: action.payload.Pan,
        Tok: action.payload.Tok,
        link: action.payload.link,
        logo: action.payload.logo,
      };
    case "CONNECTION_FAILED":
      return {
        ...initialState,
        loading: false,
        errorMsg: action.payload,
      };
    case "UPDATE_ACCOUNT":
      return {
        ...state,
        account: action.payload.account,
      };
    default:
      return state;
  }
};

export default blockchainReducer;
